module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/battle_date_bg.b3ec01c0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/battle_date_bg.png
// module id = 2953
// module chunks = 11